import { all } from 'redux-saga/effects'

import watchInterviewRequestsSaga from './interviewRequest'
import watchNotesSaga from './notes'
import watchPositionsSaga from './positions'
import watchCompetingInterviewRequestsSaga from './competingInterviewRequests'
import watchAccountManagerSaga from './accountManager'

export default function* rootSaga() {
  yield all([
    watchInterviewRequestsSaga(),
    watchNotesSaga(),
    watchPositionsSaga(),
    watchCompetingInterviewRequestsSaga(),
    watchAccountManagerSaga(),
  ])
}
